const PAYMENT_STATUS_LABELS = {
  SUCCESS: "בוצע בהצלחה",
  PAID: "שולם",
  COMPLETED: "הושלם",
  APPROVED: "אושר",
  AUTHORIZED: "אושר לחיוב",
  PENDING: "ממתין לתשלום",
  PROCESSING: "בעיבוד",
  FAILED: "נכשל",
  DECLINED: "נדחה",
  ERROR: "שגיאה",
  REFUNDED: "הוחזר",
  PARTIAL: "שולם חלקית",
  CANCELLED: "בוטל",
  CANCELED: "בוטל",
  VOID: "בוטל",
  EXPIRED: "פג תוקף",
};

export const extractPaymentStatus = (tx) => {
  if (!tx || typeof tx !== "object") return "";
  return (
    tx.status ||
    (tx.tenant_status ? String(tx.tenant_status).replace(/^[^-]+-/, "") : "")
  );
};

const normalizePaymentStatusKey = (status) =>
  String(status ?? "")
    .trim()
    .toUpperCase()
    .replace(/^[^-]+-/, "");

export const getPaymentStatusText = (status) => {
  if (!status) return "";
  const key = normalizePaymentStatusKey(status);
  if (PAYMENT_STATUS_LABELS[key]) return PAYMENT_STATUS_LABELS[key];

  if (
    key.includes("SUCCESS") ||
    key.includes("PAID") ||
    key.includes("COMPLETE")
  ) {
    return "שולם";
  }
  if (key.includes("PENDING") || key.includes("PROCESS")) {
    return "ממתין לתשלום";
  }
  if (key.includes("FAIL") || key.includes("DECLIN") || key.includes("ERROR")) {
    return "נכשל";
  }
  if (key.includes("REFUND")) return "הוחזר";
  if (key.includes("CANCEL") || key.includes("VOID")) return "בוטל";
  if (key.includes("AUTH")) return "אושר";

  return String(status);
};

export const getPaymentStatusCssClass = (status) => {
  const key = normalizePaymentStatusKey(status).toLowerCase();

  if (
    key.includes("success") ||
    key.includes("paid") ||
    key.includes("complete") ||
    key.includes("approved")
  ) {
    return "success";
  }
  if (
    key.includes("pending") ||
    key.includes("process") ||
    key.includes("auth")
  ) {
    return "pending";
  }
  if (
    key.includes("fail") ||
    key.includes("declin") ||
    key.includes("error") ||
    key.includes("cancel") ||
    key.includes("void") ||
    key.includes("refund")
  ) {
    return "failed";
  }
  return "default";
};
